// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"6cc48eab","455":"41b11d70","977":"cf4fdc4b"}[chunkId] + ".chunk.js";
};